if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.previousFocus = null;
      }

      hide() {
        super.hide();
        if (this.previousFocus) {
          this.previousFocus.focus();
        }
      }

      show(opener) {
        super.show(opener);
        this.previousFocus = document.activeElement;
        this.showActiveMedia();
      }

      // showActiveMedia() {
      //   this.querySelectorAll(
      //     `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      //   ).forEach((element) => {
      //     element.classList.remove('active');
      //   });
      //   const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      //   const activeMediaTemplate = activeMedia.querySelector('template');
      //   const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      //   activeMedia.classList.add('active');
      //   activeMedia.scrollIntoView();

      //   const container = this.querySelector('[role="document"]');
      //   container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      //   if (
      //     activeMedia.nodeName == 'DEFERRED-MEDIA' &&
      //     activeMediaContent &&
      //     activeMediaContent.querySelector('.js-youtube')
      //   )
      //     activeMedia.loadContent();
      // }

      showActiveMedia() {
        // Hide all media elements
        this.querySelectorAll("[data-media-id]").forEach((element) => {
          console.log("🚀 ~ ProductModal ~ this.querySelectorAll ~ element:", element)
          element.classList.remove("active");
          element.style.display = "none";
        });

        // Show the active media
        const activeMediaId = this.openedBy.getAttribute("data-media-id");
        const activeMedia = this.querySelector(
          `[data-media-id="${activeMediaId}"]`
        );
        activeMedia.classList.add("active");
        activeMedia.style.display = "block";

        // Scroll to the active media
        activeMedia.scrollIntoView();

        // Adjust container scrollLeft if needed
        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // Load content if it's a deferred media with YouTube
        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMedia.querySelector("template") &&
          activeMedia.querySelector(".js-youtube")
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
